import React from "react";

const Progress_bar = ({ bgcolor, progress, height, max }) => {
  const Parentdiv = {
    height: height,
    width: "100%",
    backgroundColor: bgcolor,
    borderRadius: 40,
  };

  const Childdiv = {
    height: "100%",
    width: `${(progress / max) * 100}%`,
    backgroundColor: "#0CE466",
    borderRadius: 40,
    textAlign: "right",
  };

  const progresstext = {
    padding: 10,
    color: "black",
    fontWeight: 900,
  };

  return (
    <div style={Parentdiv}>
      <div style={Childdiv}>
        <span style={progresstext}></span>
      </div>
    </div>
  );
};

export default Progress_bar;
